<template>
    <div>
        <!-- 标题 -->
        <div class="mq-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/network/CenMonitor">{{ $t('alarms.network.cen.cen') }}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.monitoringSummary') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- 查询框 -->
        <div class="mq-top">
            <Row :gutter="16">
                <Col span="8">
                    <Select v-model="timeType" @on-change="changeTimeType(timeType)">
                        <Option v-for="item in timeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>  
                </Col>
            </Row>
        </div>
        <!-- 折线图 -->
        <Row :gutter="16">
            <Col span="8" v-for="(item,index) in list" :key="index">
                <Card :padding="8">
                    <p slot="title">{{item.title}}</p>
                    <a href="#" slot="extra" @click.prevent="changeFull(item)">
                        <Icon type="ios-expand" size="18"/>
                    </a>
                    <div :id="item.id" :ref="item.id" style="width:100%;height: 240px;"></div>
                </Card>
            </Col>
        </Row>
        <!-- 放大弹出框 -->
        <Modal v-model="isShowModal" :mask-closable="false" :closable="false" width="65%">
            <Row>
                <Col span="24">
                    <h3>{{lineTitle}}</h3>
                    <div id="chart-part" ref="fullChart" style="width:100%; height:420px;"></div>
                </Col>
            </Row>
            <div slot="footer">
                <div>
                    <Button @click="cancel">{{$t('alarms.common.close')}}</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../../../utils/cookieUtil.js'
    export default {
        name: 'CEN',
        data () {
            return {
                // 放大功能
                lineTitle:'',
                isShowModal: false,
                //折线图
                list: [{
                    id: 'internetOutRateByConnectionArea',
                    title:this.$t('alarms.network.cen.line.RegionalOutflowBandwidthPercentage')
                },
                {
                    id: 'internetOutRateByConnectionRegion',
                    title:this.$t('alarms.network.cen.line.GeographicalOutboundBandwidthPercentage')
                },
                {
                    id: 'latencyByConnectionRegion',
                    title:this.$t('alarms.network.cen.line.RegionalDelayms')
                }],
                timeType:3,
                timeList:[],
                // echarts实例
                chart:'',
                chartInternetOutRateByConnectionRegion:'',
                chartLatencyByConnectionRegion:'',
                internetOutRateByConnectionAreaOption:{},
                internetOutRateByConnectionRegionOption:{},
                latencyByConnectionRegionOption:{},
                // 数组
                storageSize:[],
                getRequestCount:[],
                putRequestCount:[],
                xaxisData:[]
            }
        },
        mounted: function(){
            this.queryTimeHorizon();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chart.resize();
                self.chartInternetOutRateByConnectionRegion.resize();
                self.chartLatencyByConnectionRegion.resize();
            });
        },
        created(){
            this.queryBucketIndex();
        },
        methods: {
            /******************放大********************************/
            changeFull:function(item){
                this.isShowModal=true;
                this.lineTitle=item.title;
                this.$nextTick(() => {
                    const chartFul = this.$refs.fullChart;
                    if(chartFul){
                        const fullChart = this.$echarts.init(
                            document.getElementById("chart-part")
                        );
                        fullChart.clear();
                        if(item.id=='internetOutRateByConnectionArea'){
                            var optionFll = this.internetOutRateByConnectionAreaOption;
                        }else if(item.id=='internetOutRateByConnectionRegion'){
                            var optionFll = this.internetOutRateByConnectionRegionOption;
                        }else if(item.id=='latencyByConnectionRegion'){
                            var optionFll = this.latencyByConnectionRegionOption;
                        }
                        
                        fullChart.setOption(optionFll);
                        window.addEventListener("resize", function() {
                            fullChart.resize();
                        });    
                    }
                });
            },
            // 模态框取消事件
            cancel() {
                this.isShowModal = false;
            },
            /******************查询********************************/
            // 查询时间范围
            queryTimeHorizon: function(){
                this.$api.cloudWatch.queryTimeHorizon("userName",getCookie(global.cookieName))
                .then(res => {
                    this.timeList = res.data;
                })
            },
            // 通过问题类型查询案例
            queryBucketIndex: function(){
                this.$api.bucket.queryBucketIndex({
                    // TODO  CEN先写死
                    // "accountId":this.$route.query.accountId,
                    // "timeHorizon":this.timeType,
                    // "monitorModule":16,
                    // "instanceId":"testMQ-1",
                    // "region":this.$route.query.region
                    "accountId":147,
                    "timeHorizon":3,
                    "monitorModule":4,
                    "bucketName": "slaaron",
                    "region": "cn-shenzhen"
                })
                .then(res => {
                    this.storageSize = res.data.storageSize;
                    this.getRequestCount = res.data.getRequestCount;
                    this.putRequestCount=res.data.putRequestCount;
                    this.xaxisData = res.data.xaxisData;
                    this.init();
                   
                })
            },
            // 切换时间
            changeTimeType:function(){
                this.queryBucketIndex();
            },
            /******************所有折线图********************************/ 
            init:function(){
                this.internetOutRateByConnectionAreaLine();
                this.internetOutRateByConnectionRegionLine();
                this.latencyByConnectionRegionLine();
            },
            //区域流出带宽
            internetOutRateByConnectionAreaLine:function(){
                this.chart=this.$echarts.init(document.getElementById("internetOutRateByConnectionArea"));
                this.internetOutRateByConnectionAreaOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 区域流出带宽
                    legend: {
                        x: 'right',  
                        y: '10px',
                        data:[this.$t('alarms.network.cen.line.RegionalOutflowBandwidth')]
                    },
                    series: [{
                        name:this.$t('alarms.network.cen.line.RegionalOutflowBandwidth'),
                        type:'line',
                        data:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                        itemStyle: {
                            normal: {
                                color: "#91c7ae",
                                lineStyle: {
                                    color: "#91c7ae"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chart.setOption(this.internetOutRateByConnectionAreaOption)           
            },
            // 地域流出带宽 
            internetOutRateByConnectionRegionLine:function(){
                this.chartInternetOutRateByConnectionRegion=this.$echarts.init(document.getElementById("internetOutRateByConnectionRegion"));
                this.internetOutRateByConnectionRegionOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 地域流出带宽
                    legend: {
                        x: 'right',  
                        y: '10px',
                        data:[this.$t('alarms.network.cen.line.GeographicalOutflowBandwidth')]
                    },
                    series: [{
                        name:this.$t('alarms.network.cen.line.GeographicalOutflowBandwidth'),
                        type:'line',
                        data:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                        itemStyle: {
                            normal: {
                                color: "#c23531",
                                lineStyle: {
                                    color: "#c23531"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartInternetOutRateByConnectionRegion.setOption(this.internetOutRateByConnectionRegionOption)              
            },
            // 地域延时
            latencyByConnectionRegionLine:function(){
                this.chartLatencyByConnectionRegion=this.$echarts.init(document.getElementById("latencyByConnectionRegion"));
                this.latencyByConnectionRegionOption={
                     tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 地域延时
                    legend: {
                        x: 'right',  
                        y: '10px',
                        data:[this.$t('alarms.network.cen.line.RegionalDelay')]
                    },
                    series: [{
                        name:this.$t('alarms.network.cen.line.RegionalDelay'),
                        type:'line',
                        data:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                        itemStyle: {
                            normal: {
                                color: "#803500",
                                lineStyle: {
                                    color: "#803500"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartLatencyByConnectionRegion.setOption(this.latencyByConnectionRegionOption)
            },
            /********************************/
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.cenId=this.$route.query.cenId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/network/cenDetail/',query: {id: this.id,accountId:this.accountId,cenId:this.cenId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .mq-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-col-span-6
    {
        margin-bottom: 20px;
    }
    .mq-top
    {
        width: 100%;
        height: 53px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>





// WEBPACK FOOTER //
// src/components/monitor/network/cen/cen_dashboard/CEN.vue